import template from './componentHeader.html';

const componentHeader = {
  restrict: 'E',
  bindings: {
    title: '<',
    body: '<',
    params: '<'
  },
  template
};

export default componentHeader;
